import React, { createContext, useReducer } from "react";
import { reducer } from "./reducer";
import { initialState } from "./state";

export const KunjunganRawatJalanCtx = createContext();

function KunjunganRawatJalanContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <KunjunganRawatJalanCtx.Provider value={{ state, dispatch }}>
      {children}
    </KunjunganRawatJalanCtx.Provider>
  );
}

export default KunjunganRawatJalanContext;
